// @flow
import React from 'react';
import DefaultPage from 'Containers/DefaultPage';
import HeroHeader from 'Components/HeroHeader/deprecated';
import { Container, Row, Col } from 'Components/Grid';
import DealerModel from 'Stores/DealerModel';
import JobModel from 'Stores/JobModel';
import AssetModel from 'Stores/AssetModel';
import IconList from 'Components/IconList';
import styles from './styles.scss';

type Props = {
  job: {},
  dealer: DealerModel,
};

type State = {
  job: JobModel,
};

export default class CareerDetails extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      job: props.job instanceof JobModel ? props.job : new JobModel(props.job),
    };
  }

  render() {
    const { dealer } = this.props;
    const { job } = this.state;

    // use defaults from dealer model when no custom props are set
    const { career } = dealer.settings;
    const phone = career.contactPhone || dealer.mainContact.phone;
    const email = career.contactEmail || dealer.mainContact.email;

    return (
      <DefaultPage>
        <HeroHeader
          small
          image={
            new AssetModel({
              src: '/fileadmin/hws-content/hero-header/mmd_karriere_uebersicht_q50.jpg',
            })
          }
          title={job.title}
          subtitle="Karriere"
          backlink="/ueber-uns/autohaus/karriere"
        />
        <Container>
          <div className={styles.head}>
            <Row>
              <Col cols={12} m={6} l={7}>
                <p>{job.description}</p>
              </Col>
              <Col l={1} className={styles.hideltL} />
              <Col cols={12} m={6} l={4}>
                <IconList
                  items={[
                    { icon: 'link', label: job.getLabel('departments', job.department) },
                    { icon: 'calendar', label: job.getAvailabilityLabel() },
                    {
                      icon: 'clock',
                      label:
                        job.getLabel('workingTimes', job.workingTime) +
                        ' ' +
                        job.getLabel('limitations', job.limitation),
                    },
                    { icon: 'address', label: dealer.mainContact.city },
                  ]}
                />
              </Col>
            </Row>
          </div>
        </Container>
        <div className={styles.whiteBg}>
          <Container>
            <Row align="center">
              {job.tasks && (
                <Col cols={12} m={8} l={6}>
                  <h2>Ihre Aufgaben</h2>
                  <div dangerouslySetInnerHTML={{ __html: job.tasks }} />
                </Col>
              )}
            </Row>
            <Row align="center">
              {job.requirements && (
                <Col cols={12} m={8} l={6}>
                  <h2>Ihr Profil</h2>
                  <div dangerouslySetInnerHTML={{ __html: job.requirements }} />
                </Col>
              )}
            </Row>
            <Row align="center">
              {job.benefits && (
                <Col cols={12} m={8} l={6}>
                  <h2>Ihre Vorteile</h2>
                  <div dangerouslySetInnerHTML={{ __html: job.benefits }} />
                </Col>
              )}
            </Row>
            <Row align="center">
              <Col cols={12} m={8} l={6}>
                <div className={styles.teaser}>
                  <h2 className={styles.headline}>Kontakt</h2>
                  <p className={styles.text}>
                    Wir freuen uns auf Ihre Bewerbung. So können Sie uns kontaktieren:
                  </p>
                  <IconList
                    items={[
                      {
                        icon: 'phone',
                        label: phone,
                        link: `tel: ${phone}`,
                      },
                      {
                        icon: 'mail',
                        label: email,
                        link: `mailto: ${email}`,
                      },
                    ]}
                  />
                </div>
              </Col>
            </Row>
          </Container>
        </div>
      </DefaultPage>
    );
  }
}
